import { useMemo } from "react"

import { isEmpty } from "shared/lib/arrayUtils"
import { useUrlParamStore } from "shared/lib/url/useUrlParams"

import { useBuildingReferenceFilter } from "entities/building-references/model/useBuildingReferenceFilter"
import { buildingReferenceFilterFormDataSchema } from "entities/building-references/types/BuildingReferenceFilterFormData"
import { useProductOptions } from "entities/products/model/useProductOptions"

import { useBuildingReferenceFilterStore } from "../../../../widgets/building-reference-filter/model/useBuildingReferenceFilterStore"

export function useBuildingReferenceOverviewWidgetController() {
  const { filterState, setFilters } = useBuildingReferenceFilterStore()

  const { values, setValues } = useUrlParamStore(
    buildingReferenceFilterFormDataSchema,
    {
      state: filterState,
      setState: setFilters
    }
  )

  const { options: productOptions, isLoading: isLoadingProducts } =
    useProductOptions()

  const { buildingReferenceObjs, isLoading: isLoadingBuildingReferenceObjs } =
    useBuildingReferenceFilter(values)

  const hasFilter = useMemo(() => {
    return (
      !!values.searchTerm ||
      !isEmpty(values.products) ||
      !isEmpty(values.buildingTypes)
    )
  }, [values])

  return {
    filterState,
    hasFilter,
    productOptions,
    isLoadingProducts,
    defaultValues: values,
    buildingReferenceObjs,
    isLoadingBuildingReferenceObjs,
    onChange: setValues
  }
}
